export default __webpack_public_path__ + "static/media/negocio_um.a7046237.jpg";